// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3tZiw","content":"RecentSearches_content__3qH_W"};